import React from 'react';
import { useLanguage } from '../LanguageContext';

interface ReviewMessageProps {
  onReviewSubmit: (wasHelpful: boolean, message: string) => void;
}

export const ReviewMessage: React.FC<ReviewMessageProps> = ({ onReviewSubmit }) => {
  const { t } = useLanguage();
  
  return (
    <div className="privacy-message">
      <div className="privacy-content">
        {t('wasHelpful')}
      </div>
      <div className="btn-wrapper" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-start' }}>
        <button 
          className="accept-btn" 
          onClick={() => onReviewSubmit(true, "Thank you for your answer")}
        >
          {t('yes')}
        </button>
        <button 
          className="accept-btn" 
          onClick={() => onReviewSubmit(false, "This didn't help")}
        >
          {t('no')}
        </button>
      </div>
    </div>
  );
}; 